import './App.css';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";

import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import NotFound from "./pages/errors/NotFound";
import TripDetails from "./pages/TripDetails";
import WalletDetails from "./pages/WalletDetails";
import UpdateServerPrice from "./pages/UpdateServerPrice";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import UpdateUserWallet from "./pages/UpdateUserWallet";

function App() {

    return (
        <div className="App">
            <Router>
                <div>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/iniciar-sesion" element={<Login />} />
                        <Route path="/politicas-de-privacidad" element={<PrivacyPolicy />} />
                        <Route path="/admin/*" element={<Admin />} />
                        <Route path="/solicitud/:id" element={<TripDetails />} />
                        <Route path="/actualizar-billetera/:id" element={<UpdateUserWallet/>} />
                        <Route path="/solicitud-billetera/:id" element={<WalletDetails />} />
                        <Route path="/actualizar-precio/:id" element={<UpdateServerPrice />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>
            </Router>
        </div>
    );
}

export default App;
